export type XAxisValue = number;
export type YAxisValue = number | [number, number, number]; // for error bars
export type DataPointExtraData = {
  x: number;
  avg: number;
  min: number;
  max: number;
  stddev: number;
  runs: number;
};

export type Interpolation = boolean;

export type BucketInfo = {
  count: number;
  sum: number;
  positiveInfCount: number;
  negativeInfCount: number;
  nanCount: number;
};

export type OriginalStep = number;
export type OriginalTimestampMillis = number;

export type DataPoint = [
  XAxisValue,
  YAxisValue,
  undefined?, // unused
  DataPointExtraData?,
  Interpolation?,
  BucketInfo?,
  OriginalStep?,
  OriginalTimestampMillis?,
];

export function getDataPointX(point: DataPoint): XAxisValue {
  return point[0];
}

export function getDataPointMin(point: DataPoint): number {
  return Array.isArray(point[1]) ? point[1][0] : point[1];
}

export function getDataPointValue(point: DataPoint): number {
  return Array.isArray(point[1]) ? point[1][1] : point[1];
}

export function getDataPointMax(point: DataPoint): number {
  return Array.isArray(point[1]) ? point[1][2] : point[1];
}

export function getDataPointExtraData(point: DataPoint): DataPointExtraData | undefined {
  return point[3];
}

export function getDataPointInterpolationFlag(point: DataPoint): Interpolation | undefined {
  return point[4];
}

export function getDataPointBucket(point: DataPoint): BucketInfo | undefined {
  return point[5];
}

export function getDataPointStep(point: DataPoint): OriginalStep | undefined {
  return point[6];
}

export function getDataPointTimestampMillis(point: DataPoint): OriginalTimestampMillis | undefined {
  return point[7];
}

export function hasNonFiniteValues(bucket: BucketInfo): boolean {
  return bucket.positiveInfCount > 0 || bucket.negativeInfCount > 0 || bucket.nanCount > 0;
}

export function getNonFiniteTypesInBucket(
  bucket: BucketInfo,
): Array<'positive-inf' | 'negative-inf' | 'nan'> {
  const types: Array<'positive-inf' | 'negative-inf' | 'nan'> = [];

  if (bucket.positiveInfCount > 0) {
    types.push('positive-inf');
  }

  if (bucket.negativeInfCount > 0) {
    types.push('negative-inf');
  }

  if (bucket.nanCount > 0) {
    types.push('nan');
  }

  return types;
}
